import getters from './getters';
import actions from './actions';
import mutations from './mutations';
const state = {
  current: parseInt(sessionStorage.getItem('current_brand', null)) || null,
  available: []
};
export default {
  state,
  getters,
  actions,
  mutations
};
